import { Pipe, PipeTransform } from '@angular/core';
import { Day } from '@shared/components/date-picker/model';

@Pipe({
  name: 'isDateIsAvailable',
  standalone: true,
})
export class IsDateIsAvailablePipe implements PipeTransform {
  transform(day: Day[], index: number): boolean {
    return day[index]!['schedules'].length > 0;
  }
}
